import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Router } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory'
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import ScrollToTop from './config/ScrollToTop';

import './assets/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './index.css';

ReactGA.initialize('UA-77663647-5');

const history = createBrowserHistory();
history.listen((location) => {
	ReactGA.set({ page: location.pathname });
	ReactGA.pageview(location.pathname);
});

const Root = () => (
	<Router basename="/" history={history}>
		<ScrollToTop>
			<App />
		</ScrollToTop>
	</Router>
);

ReactDOM.render(<Root />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js